class CodeTextEnum {
  constructor(name) {
    this.name = name
  }
}

// 実施の判断
const messageCodeEnum = Object.freeze({
  E00000001: new CodeTextEnum('E00000001'), //{0}を入力してください。
  E00000002: new CodeTextEnum('E00000002'), //半角英数字を入力してください。
  E00000003: new CodeTextEnum('E00000003'), //システムエラーが発生しました。システム管理者へ連絡してください。
  I00000004: new CodeTextEnum('I00000004'), //{0}を登録してよろしいですか。
  I00000005: new CodeTextEnum('I00000005'), //一覧画面へ戻ります。よろしいですか？
  E00000006: new CodeTextEnum('E00000006'), //{0}と関連している{1}を入力してください。
  E00000007: new CodeTextEnum('E00000007'), //指定された{0}は{1}に存在しません。
  E00000008: new CodeTextEnum('E00000008'), //正しい日付を設定してください。
  E00000009: new CodeTextEnum('E00000009'), //{0}は{1}よりも後に設定してください。
  E00000010: new CodeTextEnum('E00000010'), //ログオンユーザーには{0}の権限がありません。
  E00000011: new CodeTextEnum('E00000011'), //有効なEメールアドレスを入力してください。
  E00000012: new CodeTextEnum('E00000012'), //有効なURLを入力してください。
  E00000013: new CodeTextEnum('E00000013'), //有効な日付を入力してください。
  E00000014: new CodeTextEnum('E00000014'), //有効な数字を入力してください。
  E00000015: new CodeTextEnum('E00000015'), //数字のみ入力してください。
  E00000016: new CodeTextEnum('E00000016'), //有効なクレジットカード番号を入力してください。
  E00000017: new CodeTextEnum('E00000017'), //同じ値をもう一度入力してください。
  E00000018: new CodeTextEnum('E00000018'), //有効な拡張子を含む値を入力してください。
  E00000019: new CodeTextEnum('E00000019'), //{0} 文字以内で入力してください。
  E00000020: new CodeTextEnum('E00000020'), //{0} 文字以上で入力してください。
  E00000021: new CodeTextEnum('E00000021'), //{0} 文字から {1} 文字までの値を入力してください。
  E00000022: new CodeTextEnum('E00000022'), //{0} から {1} までの値を入力してください。
  E00000023: new CodeTextEnum('E00000023'), //{0} の倍数を入力してください。
  E00000024: new CodeTextEnum('E00000024'), //{0} 以下の値を入力してください。
  E00000025: new CodeTextEnum('E00000025'), //{0} 以上の値を入力してください。
  E00000026: new CodeTextEnum('E00000026'), //{0} ファイルが見つかりませんでした。
  E00000027: new CodeTextEnum('E00000027'), //{0} ファイルを開くことができません。
  W00000028: new CodeTextEnum('W00000028'), //建物ＣＤ、棟ＣＤ、得意先ＣＤ、商品ＣＤが同一の契約管理ＮＯが存在しています。
  E00000029: new CodeTextEnum('E00000029'), //見積採用できるのは一件です。
  E00000030: new CodeTextEnum('E00000030'), //{0} にチェックが入っていません。
  W00000031: new CodeTextEnum('W00000031'), //{0} は{1} 以降に設定されています。
  W00000033: new CodeTextEnum('W00000033'), //出力データがありません。
  W00000034: new CodeTextEnum('W00000034'), //データを選択してください。
  E00000035: new CodeTextEnum('E00000035'), //一回の印刷で最大{0}個まで選択できます。
  E00000036: new CodeTextEnum('E00000036'), //まだ処理中のデータがあります。処理が終わってから、再度ダウンロードしてください。
  E00000037: new CodeTextEnum('E00000037'), //{0}は{1}よりも前に設定してください。
  E00000038: new CodeTextEnum('E00000038'), //{0}となるため、{1}は変更できません。
  E00000039: new CodeTextEnum('E00000039'), //{0}は{1}と一致しません。
  W00000040: new CodeTextEnum('W00000040'), //{0} が変更されています。
  E00000041: new CodeTextEnum('E00000041'), //{0} を入力してください。
  E00000042: new CodeTextEnum('E00000042'), //選択された{0} は採用できません。
  E00000043: new CodeTextEnum('E00000043'), //{0} には{1}がありません。
  E00000044: new CodeTextEnum('E00000044'), //選択された{0} は発注できません。
  E00000045: new CodeTextEnum('E00000045'), //発注先がECO連携対象外のため、ECO連携はできません。
  E00000046: new CodeTextEnum('E00000046'), //{0}を選択してください。
  E00000047: new CodeTextEnum('E00000047'), //{0}は変更できません。
  E00000048: new CodeTextEnum('E00000048'), //複写したい明細をご選択ください。
  E00000049: new CodeTextEnum('E00000049'), //選択されている商品の商品明細を入力してください。
  E00000050: new CodeTextEnum('E00000050'), //工事記録簿より見積採用依頼されていません。
  E00000051: new CodeTextEnum('E00000051'), //こちらの見積枝番は工事記録簿より採用された見積枝番と異なります。工事記録簿より採用された枝番は{0}番です。
  W00000052: new CodeTextEnum('W00000052'), //該当データがありません。
  E00000053: new CodeTextEnum('E00000053'), //{0}に{1}の登録がありません。
  E00000054: new CodeTextEnum('E00000054'), //半角ｶﾅのみ入力可能です。
  E00000055: new CodeTextEnum('E00000055'), //選択されたデータは「{0}:{0}」が保留中のため、保留できません。
  E00000056: new CodeTextEnum('E00000056'), //{0}は既に{1}に登録されています。
  E00000057: new CodeTextEnum('E00000057'), //インポートファイルは存在しません。
  E00000058: new CodeTextEnum('E00000058'), //{0}以降の年月を入力してください。
  E00000059: new CodeTextEnum('E00000059'), //{0} が指定されていません。
  E00000060: new CodeTextEnum('E00000060'), //{0} が{1} に登録されていません。
  E00000061: new CodeTextEnum('E00000061'), //{0}桁で入力してください。
  E00000062: new CodeTextEnum('E00000062'), //請求支払区分が「{0}」の{1}を入力してください。
  E00000063: new CodeTextEnum('E00000063'), //使用可能な{0}を入力してください。
  E00000064: new CodeTextEnum('E00000064'), //指定された{0}は{1}できません。
  E00000065: new CodeTextEnum('E00000065'), //指定された{0}は{1}ではありません。
  E00000066: new CodeTextEnum('E00000066'), //指定された{0}は{1}しています。
  E00000067: new CodeTextEnum('E00000067'), //指定された{0}は{1}です。
  E00000068: new CodeTextEnum('E00000068'), //指定された{0}は{1}されていません。
  E00000069: new CodeTextEnum('E00000069'), //{0}に{1}は指定できません。
  E00000070: new CodeTextEnum('E00000070'), //指定された{0}が{1}と一致しません。
  E00000071: new CodeTextEnum('E00000071'), //指定された{0}が{1}に存在しません。
  E00000072: new CodeTextEnum('E00000072'), //指定された{0}の{1}が正しくありません。
  E00000073: new CodeTextEnum('E00000073'), //{0}を指定してください。
  E00000074: new CodeTextEnum('E00000074'), //作業完了または原価計上されているため、{0}は変更できません。
  E00000075: new CodeTextEnum('E00000075'), //月間回数が限度数を超えています。
  E00000076: new CodeTextEnum('E00000076'), //{0}の場合、{1}に{2}を含めることはできません。
  E00000077: new CodeTextEnum('E00000077'), //{0}は{1}以下の金額を指定してください。
  E00000078: new CodeTextEnum('E00000078'), //{0}されていないため、{1}できません。
  E00000079: new CodeTextEnum('E00000079'), //原価金額がｾﾞﾛ円以外の為、原価ｾﾞﾛ発注Cを入力できません。
  E00000080: new CodeTextEnum('E00000080'), //一回の検索で最大{0}個まで指定することができます。
  E00000081: new CodeTextEnum('E00000081'), //{0}桁または{0}桁以上の{1}を入力してください。
  E00000082: new CodeTextEnum('E00000082'), //最大{0}年間のみ指定できます。
  W00000083: new CodeTextEnum('W00000083'), //{0}が{1}より前の日付になっています。
  E00000084: new CodeTextEnum('E00000084'), //{0} データをクエリすると、複数のレコードが返されます。
  E00000085: new CodeTextEnum('E00000085'), //指定された受注キーは受注で商品明細が取消されているため、登録・変更できません。
  E00000086: new CodeTextEnum('E00000086'), //指定された受注キーは年次決算済みのため、登録できません。
  E00000087: new CodeTextEnum('E00000087'), //指定された受注キーは登録可能な受注ステータスではないため、登録・変更できません。
  E00000088: new CodeTextEnum('E00000088'), //指定された受注キーは登録可能な見積ステータスではないため、登録・変更できません。
  E00000089: new CodeTextEnum('E00000089'), //指定された{0}に紐づく{1}の登録がありません。
  E00000090: new CodeTextEnum('E00000090'), //特例の場合のみ、支払予定日が入力できます。
  E00000091: new CodeTextEnum('E00000091'), //発注書別途作成の場合、ECO文書は利用できません。
  E00000092: new CodeTextEnum('E00000092'), //指定の発注先CDは、採用された見積に存在しません。
  E00000093: new CodeTextEnum('E00000093'), //特定部門のみ選択可能です。
  E00000094: new CodeTextEnum('E00000094'), //指定された発注書出力区分はオフィスファシリティ部のみ指定できます。
  E00000095: new CodeTextEnum('E00000095'), //連絡先部門住所CDがブランクの場合、進行部門CDを連絡先部門住所CDに指定してください。
  E00000096: new CodeTextEnum('E00000096'), //すでに月間回数が登録されている場合、月間回数には1回以上を指定してください。
  E00000097: new CodeTextEnum('E00000097'), //すでに承認されているため、月間回数は変更できません。
  E00000098: new CodeTextEnum('E00000098'), //作業年月と回数が指定されていないため、{0}の指定はできません。
  E00000099: new CodeTextEnum('E00000099'), //原価または差込まれたデータが存在する場合、発注取消はできません。
  E00000100: new CodeTextEnum('E00000100'), //作業年月と納品予定日の年月が一致しません。
  E00000101: new CodeTextEnum('E00000101'), //指定された契約予定期間は、契約基本の原始契約期間外（{0} ～{1} ）です。
  E00000102: new CodeTextEnum('E00000102'), //指定された{0}は取引できません。
  E00000103: new CodeTextEnum('E00000103'), //発注詳細を取り消す場合、発注金額税抜には「0」円を指定してください。
  E00000104: new CodeTextEnum('E00000104'), //該当するデータは見つかりませんでした。
  E00000105: new CodeTextEnum('E00000105'), //{0}を選択してください。
  E00000106: new CodeTextEnum('E00000106'), //通知宛先設定は、複数の協力会社を同時に設定できません。
  E00000107: new CodeTextEnum('E00000107'), //{0}の終了日が開始日より前の日付になっています。
  I00000108: new CodeTextEnum('I00000108'), //{0}を登録しました。
  I00000109: new CodeTextEnum('I00000109'), //{0}を更新しました。
  I00000110: new CodeTextEnum('I00000110'), //{0}を削除しました。
  I00000111: new CodeTextEnum('I00000111'), //{0}しました。
  I00000112: new CodeTextEnum('I00000112'), //作業日程をクリアします。よろしいですか？
  W00000113: new CodeTextEnum('W00000113'), //後続業務に影響があるため、できれば25日以降の日程を避けてください。
  E00000114: new CodeTextEnum('E00000114'), //（{0}）の作業可能日依頼情報はすでに存在しています。
  E00000115: new CodeTextEnum('E00000115'), //{0}は半角英数字を入力してください。
  E00000116: new CodeTextEnum('E00000116'), //報告書提出状況が次のステータスに該当する発注を選択してください。「{0}」、「{1}」、「{2}」
  E00000117: new CodeTextEnum('E00000117'), //{0}できるファイルが見つかりません。
  E00000118: new CodeTextEnum('E00000118'), //（{0}、{1}、{2}）の依頼は日程提出催促対象ではありません。
  E00000119: new CodeTextEnum('E00000119'), //（{0}、{1}、{2}）の依頼は書類提出催促対象ではありません。
  E00000120: new CodeTextEnum('E00000120'), //{0}は書類提出催促対象ではありません。
  E00000121: new CodeTextEnum('E00000121'), //候補日程/対応日程は、最大{0}件以内で入力してください。
  E00000122: new CodeTextEnum('E00000122'), //（{0}、{1}）の日程調整依頼は既に登録されています。
  E00000123: new CodeTextEnum('E00000123'), //半角で入力してください。
  E00000124: new CodeTextEnum('E00000124'), //パラメーターが正しくありません。
  E00000125: new CodeTextEnum('E00000125'), //{0}データが取得できませんでした。
  W00000126: new CodeTextEnum('W00000126'), //仮登録工期が確定工期と一致しないため、着工日程調整情報を修正しました。
  W00000127: new CodeTextEnum('W00000127'), //{0}にクエリされていないデータ。
  W00000128: new CodeTextEnum('W00000128'), //現在の操作は{0}の場合にのみ適用されます。
  E00000129: new CodeTextEnum('E00000129'), //データが入力されていません。
  E00000130: new CodeTextEnum('E00000130'), //商品コードが{0}の場合、{1}は必須項目です。
  E00000131: new CodeTextEnum('E00000131'), //該当データが存在しないため、取消できません。
  E00000132: new CodeTextEnum('E00000132'), //権限がないため、取消できません。
  E00000133: new CodeTextEnum('E00000133'), //原価が発生しました。取消できません。
  E00000134: new CodeTextEnum('E00000134'), //インポートデータが存在しません。
  E00000135: new CodeTextEnum('E00000135'), //一度にインポートできる件数を超えています。取込ファイル最大件数：{0}
  W00000136: new CodeTextEnum('W00000136'), //入力した{0}は「建物基本マスタ」の「管理終了ﾌﾗｸﾞ」がセットされています。よろしいですか？
  E00000137: new CodeTextEnum('E00000137'), //「電子版工事記録簿」対象となるため、「{0}」の変更はできません。
  W00000138: new CodeTextEnum('W00000138'), //入力した{0}と{1}が異なっています。よろしいですか？
  E00000139: new CodeTextEnum('E00000139'), //一括請求する場合、受注請求の納品予定日は最も遅い納品予定日を指定してください。
  E00000140: new CodeTextEnum('E00000140'), //{0}は0以上を入力してください。
  E00000141: new CodeTextEnum('E00000141'), //{0}を指定した場合、{1}は必須です。
  E00000142: new CodeTextEnum('E00000142'), //共通原価集計用への変更はできません。
  E00000143: new CodeTextEnum('E00000143'), //共通原価集計用からの変更はできません。
  E00000144: new CodeTextEnum('E00000144'), //発注データが存在しているため、{0}は指定できません。
  E00000145: new CodeTextEnum('E00000145'), //入金済みのため、{0}は指定できません。
  I00000146: new CodeTextEnum('I00000146'), //納品完了しているため、{0}を指定してもよろしいですか？
  I00000147: new CodeTextEnum('I00000147'), //変更中の受注データは削除されます。よろしいですか？
  I00000148: new CodeTextEnum('I00000148'), //「請求書送付先別指定」、「請求書送付先」、「請求書送付先担当者」の値をクリアしてもよろしいですか？
  E00000149: new CodeTextEnum('E00000149'), //「金額ゼロ種別」がﾌﾞﾗﾝｸではないため、{0}を追加できません。
  E00000150: new CodeTextEnum('E00000150'), //指定された{0}はすでに登録されています。
  E00000151: new CodeTextEnum('E00000151'), //金種ゼロ種別を指定した場合、{0}は0円のみ指定できます。
  E00000152: new CodeTextEnum('E00000152'), //立替金の場合、受注承認者は経理財務部の課長のみです。
  E00000153: new CodeTextEnum('E00000153'), //進行部門がオフィスファシリティ部の場合、{0}を指定してください。
  E00000154: new CodeTextEnum('E00000154'), //{0}の後に、期処理された受注詳細データが存在しています。
  E00000155: new CodeTextEnum('E00000155'), //{0}が0円以下では登録できません。
  E00000156: new CodeTextEnum('E00000156'), //{0}、{1}の指定に誤りがあります。
  E00000157: new CodeTextEnum('E00000157'), //発注データが存在している{0}の取消はできません。
  E00000158: new CodeTextEnum('E00000158'), //{0}は本日以降の日付を指定してください。
  E00000159: new CodeTextEnum('E00000159'), //{0}は指定できません。
  E00000160: new CodeTextEnum('E00000160'), //オフィスファシリティ部は{0}、{1}を指定してください。
  E00000161: new CodeTextEnum('E00000161'), //オフィスファシリティ部以外は{0}、{1}は指定できません。
  E00000162: new CodeTextEnum('E00000162'), //金種ゼロ種別を指定した場合、{0}は変更できません。
  E00000163: new CodeTextEnum('E00000163'), //入金済みのため、{0}は変更できません。
  E00000164: new CodeTextEnum('E00000164'), //{0}は契約期間内の日付を指定してください。
  W00000165: new CodeTextEnum('W00000165'), //直接受注登録では、建物管理マスタまたは、提案計画に紐付けされません。
  E00000166: new CodeTextEnum('E00000166'), //「契約管理ＮＯ」に紐付く建物管理マスタが存在しているため、直接受注登録ができません。
  E00000167: new CodeTextEnum('E00000167'), //請求税額の入力は±1円のみ可能です。
  E00000168: new CodeTextEnum('E00000168'), //一括請求の場合、複数行の受注請求は登録できません。
  I00000169: new CodeTextEnum('I00000169'), //発注・内製登録予定のデータが存在しています。発注・内製登録予定画面に遷移してもよろしいですか？
  E00000170: new CodeTextEnum('E00000170'), //請求金額税抜計が「0円」です。受注請求を取り消してください。
  I00000171: new CodeTextEnum('I00000171'), //一括請求にする場合、有効な受注請求データは１行だけにしてください。
  E00000172: new CodeTextEnum('E00000172'), //建物の管理が開始されていないため、{0}は{1}：" {2}" 以降を入力して下さい。
  E00000173: new CodeTextEnum('E00000173'), //請求済みのため、{0}は変更できません。
  E00000174: new CodeTextEnum('E00000174'), //選択した{0}のフォーマットが正しくないため、インポートできません。
  I00000175: new CodeTextEnum('I00000175'), //該当マンションの会計対象データを減額したい場合、該当データを新規追加行にコピーします。
  E00000176: new CodeTextEnum('E00000176'), //商品ＣＤが0001の場合、{0}は{1}を入力してください。
  E00000177: new CodeTextEnum('E00000177'), //期ＣＤがｾｯﾄされている場合、{0}は変更できません。
  E00000178: new CodeTextEnum('E00000178'), //月額基本の取消フラグがチェックされている場合、{0}は変更できません。
  E00000179: new CodeTextEnum('E00000179'), //外製の発注データが存在するため、内製への変更はできません。
  E00000180: new CodeTextEnum('E00000180'), //内製の発注データが存在するため、外製への変更はできません。
  E00000181: new CodeTextEnum('E00000181'), //「契約開始日」は、同一年月内にしてください。
  E00000182: new CodeTextEnum('E00000182'), //入金日印字フラグが"1"ではないため、{0}は指定できません。
  E00000183: new CodeTextEnum('E00000183'), //入金された商品明細の月額基本は取消しできません。
  W00000184: new CodeTextEnum('W00000184'), //対象期間の発注が発注キャンセル済みであることをご確認ください。
  W00000185: new CodeTextEnum('W00000185'), //変更後、契約期間外の受注詳細はキャンセルされます。
  E00000186: new CodeTextEnum('E00000186'), //「契約終了日」の翌月以降に、取消されてない発注データが存在しています。
  I00000187: new CodeTextEnum('I00000187'), //発注・内製登録予定のデータが存在しています。発注・内製登録予定画面に遷移してもよろしいですか？
  I00000188: new CodeTextEnum('I00000188'), //受注請求データをクリアして、契約期間、受注詳細より再表示してもよろしいですか？
  I00000189: new CodeTextEnum('I00000189'), //登録確認依頼を行いました。受注キーは、{0}です。引き続き{1}画面へ遷移します。
  I00000190: new CodeTextEnum('I00000190'), //登録確認依頼を行いました。受注キーは、{0}です。
  I00000191: new CodeTextEnum('I00000191'), //{0}してよろしいですか？
  E00000192: new CodeTextEnum('E00000192'), //納品後請求で納品完了日が入力されている場合、請求予定日を設定して下さい。
  E00000193: new CodeTextEnum('E00000193'), //入金日印刷不要は指定できません。
  E00000194: new CodeTextEnum('E00000194'), //依頼状況のステータスが「提出済み」の依頼は削除できません。
  E00000195: new CodeTextEnum('E00000195'), //{0}の通知先に1件以上を入力してください。
  W00000196: new CodeTextEnum('W00000196'), //同一「商品明細」、「発注先」で、既に発注登録が行われています。
  I00000197: new CodeTextEnum('I00000197'), //被請求書を取消します。よろしいですか？よろしければ「OK」ボタンを押してください。
  I00000198: new CodeTextEnum('I00000198'), //被請求書を取消しました。作業完了取消画面に遷移してもよろしいですか？
  I00000199: new CodeTextEnum('I00000199'), //入力した{0}は「会計マスタ」に存在しないため、{0}は「{1}01」をセットします。
  E00000200: new CodeTextEnum('E00000200'), //{0}の後に、入金処理された受注請求データが存在しています。
  W00000201: new CodeTextEnum('W00000201'), //既に発注データが存在するため、{0}～{1}の発注データが作成できません。ご確認ください。
  E00000202: new CodeTextEnum('E00000202'), //{0}が失敗しました。
  I00000203: new CodeTextEnum('I00000203'), //メールの送信が完了しました。
  E00000204: new CodeTextEnum('E00000204'), //入力されたデータが重複しています。
  E00000205: new CodeTextEnum('E00000205'), //メイン担当者が{0}のみ設定できます。
  E00000206: new CodeTextEnum('E00000206'), //検索条件が入力されていません。入力してから保存してください。
  E00000207: new CodeTextEnum('E00000207'), //最大保存件数は{0}件です。
  E00000208: new CodeTextEnum('E00000208'), //入力された依頼年月と依頼部門で、新規の作業可能日依頼はできません。
  E00000209: new CodeTextEnum('E00000209'), //SC3の予備調査以外で、複数案件の選択は不可です。
  E00000211: new CodeTextEnum('E00000211'), //Excel出力中にエラーが発生しました。
  E00000212: new CodeTextEnum('E00000212'), //{0}への接続でエラーが発生しました。
  W00000213: new CodeTextEnum('W00000213'), //候補日に不可日が含まれています。
  W00000214: new CodeTextEnum('W00000214'), //作業予定月と日程調整予定月が一致しません。発注詳細の作業年月を更新してください。
  E00000215: new CodeTextEnum('E00000215'), //（候補日程/対応日程）は不可日以外を選択してください。
  W00000216: new CodeTextEnum('W00000216'), //候補日程が作業予実の日程と重複しています。登録してもよろしいですか？
  W00000217: new CodeTextEnum('W00000217'), //（候補日程/対応日程）が他の予定と重複しています。
  W00000218: new CodeTextEnum('W00000218'), //工事日程が納品月とずれています。
  W00000219: new CodeTextEnum('W00000219'), //{0}と{1}は異なっています。よろしいですか？
  E00000220: new CodeTextEnum('E00000220'), //pdf出力中にエラーが発生しました。
  I00000221: new CodeTextEnum('I00000221'), //進行部門CDを変更すると、商品明細リストが初期化されます。よろしいですか？
  I00000222: new CodeTextEnum('I00000222'), //商品明細CDを変更すると、発注詳細が初期化されます。よろしいですか？
  E00000223: new CodeTextEnum('E00000223'), //指定された受注キーは、外製発注可能な商品明細が登録されていません。
  E00000224: new CodeTextEnum('E00000224'), //指定された受注キーは、内製発注可能な商品明細が登録されていません。
  E00000225: new CodeTextEnum('E00000225'), //支店長代理以外の承認者を選択してください。
  E00000226: new CodeTextEnum('E00000226'), //契約期間内の年月を入力してください。
  E00000227: new CodeTextEnum('E00000227'), //{0}から{1}への変更はできません。
  W00000228: new CodeTextEnum('W00000228'), //変更された発注先が既に発注登録が行われています。
  E00000229: new CodeTextEnum('E00000229'), //売価入力完了チェックの前に、原価入力完了チェックが必須です。
  E00000230: new CodeTextEnum('E00000230'), //{0} が{1} に対応していません。
  E00000231: new CodeTextEnum('E00000231'), //同一の商品ＣＤ＋商品明細ＣＤを複数入力することはできません。
  E00000232: new CodeTextEnum('E00000232'), //立替金の場合、{0}は必須となります。
  E00000233: new CodeTextEnum('E00000233'), //立替金の場合、請求予定日には明日以降から翌月末までが入力可能です。
  E00000234: new CodeTextEnum('E00000234'), //{0}は{1}以降を入力してください。
  I00000235: new CodeTextEnum('I00000235'), //請求予定日、入金予定日が入力されているため、納品前請求で作成されます。
  I00000236: new CodeTextEnum('I00000236'), //立替金のため、納品前請求で作成されます。
  I00000237: new CodeTextEnum('I00000237'), //作業ＮＯが入力されていないデータが存在します。未入力の場合、登録対象外となりますが、よろしいですか？よろしければ『OK』ボタンを押してください。
  I00000238: new CodeTextEnum('I00000238'), //対応状況は「異常なし」として登録を行いますが、よろしいですか？よろしければ『OK』ボタンを押してください。
  I00000239: new CodeTextEnum('I00000239'), //作業ＮＯが入力されていないデータが存在します。未入力の場合、登録対象外となります。また、対応状況は「異常なし」として登録を行います。よろしければ『OK』ボタンを押してください。
  I00000240: new CodeTextEnum('I00000240'), //登録を行います。よろしければ『OK』ボタンを押してください。
  E00000241: new CodeTextEnum('E00000241'), //有効な受注詳細データを1件以上入力してください。
  E00000242: new CodeTextEnum('E00000242'), //原価計上されているため、発注は変更できません。
  E00000243: new CodeTextEnum('E00000243'), //{0}と紐づける{1}を入力してください。
  E00000244: new CodeTextEnum('E00000244'), //提案計画の予定原価総額により、指定された「見積提出期限」は条件を満たしていません。
  E00000245: new CodeTextEnum('E00000245'), //{0}可能なデータがありません。
  E00000246: new CodeTextEnum('E00000246'), //すでに承認待ちになっています。承認されるのをお待ちください。
  I00000247: new CodeTextEnum('I00000247'), //{0}が成功しました。
  E00000248: new CodeTextEnum('E00000248'), //工事記録簿の受注確認登録が未承認のため、見積採用できません。
  E00000249: new CodeTextEnum('E00000249'), //{0} は{1}以降を指定してください。
  E00000250: new CodeTextEnum('E00000250'), //{0} は{1}以前を指定してください。
  E00000251: new CodeTextEnum('E00000251'), //納品予定年月が2019年9月以前のため、軽減税率の商品明細は指定できません。
  E00000252: new CodeTextEnum('E00000252'), //{0} が{1}を超えています。
  I00000253: new CodeTextEnum('I00000253'), //既にバッチが起動されていた為、処理を終了します。
  I00000254: new CodeTextEnum('I00000254'), //バッチが開始しました。
  E00000255: new CodeTextEnum('E00000255'), //データベース接続エラーにより、実行が失敗しました。
  I00000256: new CodeTextEnum('I00000256'), //バッチが終了しました。result={0}
  I00000257: new CodeTextEnum('I00000257'), //登録の実行が成功しました。バッチID：{0}
  E00000258: new CodeTextEnum('E00000258'), //{0}行目のでデータが読込出来ません。 {1}
  E00000259: new CodeTextEnum('E00000259'), //パラメータの指定が間違っています。パラメータ：{0}
  E00000260: new CodeTextEnum('E00000260'), //想定外のエラーが発生しました。
  I00000261: new CodeTextEnum('I00000261'), //SFTPサーバへの連携処理が成功しました。
  E00000262: new CodeTextEnum('E00000262'), //SFTPサーバへの連携処理が失敗しました。
  E00000263: new CodeTextEnum('E00000263'), //提案計画活動中以外、あるいは受注登録中のため、見積採用できません。
  I00000264: new CodeTextEnum('I00000264'), //完了報告日が削除されたため、完了報告を取り消します。よろしいですか？
  I00000265: new CodeTextEnum('I00000265'), //協力会社に候補日程を差し戻します。よろしいですか？
  I00000266: new CodeTextEnum('I00000266'), //{0}が完了しました。
  I00000270: new CodeTextEnum('I00000270'), //設定した内容で資料を連携しますか？
  I00000271: new CodeTextEnum('I00000271'), //選択した日程で確定しますか？
  E00000275: new CodeTextEnum('E00000275'), //存在しない年月が入力されています。
  I00000277: new CodeTextEnum('I00000277'), //案件1件と作業日をマッチングしました。設定した内容で依頼しますか？
  I00000279: new CodeTextEnum('I00000279'), //依頼の取り消しを実行しますか？
  I00000280: new CodeTextEnum('I00000280'), //照会の結果が見つかりません。
  E00000281: new CodeTextEnum('E00000281'), //報告書提出状態が「提出済」「差戻」「確認済」の発注のみ選択できます。
  W00000285: new CodeTextEnum('W00000285'), //（候補日程/対応日程）がFM不可日と重複しています。
  W00000286: new CodeTextEnum('W00000286'), //（候補日程/対応日程）が建物不可日と重複しています。
  I00000287: new CodeTextEnum('I00000287'), //選択した協力会社と案件の組み合わせで、{0}の提出を催促しますか？
  E00000288: new CodeTextEnum('E00000288'), //報告書提出状態が「提出済」の発注を選択してください。
  I00000291: new CodeTextEnum('I00000291'), //設定した内容を登録して次の担当者に確認を依頼します。よろしいですか？
  E00000295: new CodeTextEnum('E00000295'), //（候補日程/対応日程）を入力してください。
  I00000297: new CodeTextEnum('I00000297'), //選択したXXXを削除します。よろしいですか？
  E00000300: new CodeTextEnum('E00000300'), //提出必須の書類をアップロードしてください。
  I00000301: new CodeTextEnum('I00000301'), //設定した内容で{0}します。よろしいでしょうか？
  E00000302: new CodeTextEnum('E00000302'), //固定電話番号は10桁、携帯電話番号は11桁を入力してください。
  E00000304: new CodeTextEnum('E00000304'), //通知先に1件以上を入力してください。
  E00000305: new CodeTextEnum('E00000305'), //すべての書類を提出してください。
  E00000306: new CodeTextEnum('E00000306'), //受注の計上部門または進行部門を選んでください。
  E00000307: new CodeTextEnum('E00000307'), //他のユーザーによって変更された可能性があります。最新の状態で再度実行してください。
  E00000308: new CodeTextEnum('E00000308'), //他のユーザーが編集中の可能性があります。最新の状態で再度実行してください。
  W00000309: new CodeTextEnum('W00000309'), //発行対象が存在しません。
  I00000310: new CodeTextEnum('I00000310'), //{0}、受注請求データを再計算してもよろしいでしょうか？
  I00000311: new CodeTextEnum('I00000311'), //税率が変わったので、一括請求にしてください。
  E00000312: new CodeTextEnum('E00000312'), //インポートファイル名が「提案計画インポートデータ*.xls」、「提案計画インポートデータ*.xlsx」ではありません。
  E00000313: new CodeTextEnum('E00000313'), //1行目に「【提案計画インポートデータ】」の文字列が存在しません。
  E00000314: new CodeTextEnum('E00000314'), //2行目に項目のタイトルが存在しません。
  E00000315: new CodeTextEnum('E00000315'), //1行目H列に「【提案計画インポート済み】」の文字列が存在しています。
  I00000316: new CodeTextEnum('I00000316'), //既に、該当データのコピーした新規追加行が存在するため、重複する新規追加行は削除してもよろしいでしょうか？
  E00000317: new CodeTextEnum('E00000317'), //工事記録簿対象外のため、{0}は入力できません。
  E00000318: new CodeTextEnum('E00000318'), //インポートファイル名が「{0}*.xls」、{「{1}*.xlsx」」ではありません。
  E00000319: new CodeTextEnum('E00000319'), //1行目に「{0}」の文字列が存在しません。
  E00000320: new CodeTextEnum('E00000320'), //{0}行目に項目のタイトルが存在しません。
  E00000321: new CodeTextEnum('E00000321'), //1行目H列に「{0}」の文字列が存在しています。
  I00000322: new CodeTextEnum('I00000322'), //他の案件に切り替えますか？
  E00000323: new CodeTextEnum('E00000323'), //{0}をアップロードしてください。
  I00000324: new CodeTextEnum('I00000324'), //他の作業日に切り替えますか？
  E00000325: new CodeTextEnum('E00000325'), //見積採用済みの為、採用は出来ません。
  W00000326: new CodeTextEnum('W00000326'), //現在の検索条件では可能日依頼がないため、後続の作業日マッチングを実行できません。検索条件を変更してください。
  W00000327: new CodeTextEnum('W00000327'), //他のユーザーによって更新された可能性があります。画面を更新し、再操作してください。
  I00000328: new CodeTextEnum('I00000328'), //「納品予定年月」または「契約予定期間」が変更されたので、作業年月も変更してください。
  E00000329: new CodeTextEnum('E00000329'), //インポートファイル名が「受注承認待ちインポートデータ*.xls」、「受注承認待ちインポートデータ*.xlsx」ではありません。
  I00000330: new CodeTextEnum('I00000330'), //年次・月次決算で全て売上確定されたため、変更できません。
  E00000331: new CodeTextEnum('E00000331'), //「未入力催促」の対象となる作業予定はありませんでした。
  E00000332: new CodeTextEnum('E00000332'), //入力してください。
  E00000333: new CodeTextEnum('E00000333'), //選択してください。
  E00000334: new CodeTextEnum('E00000334'), //報告書提出状態が{0}、{1}の対象だけ選択してください。
  I00000335: new CodeTextEnum('I00000335'), //選択した対象データは報告書提出を催促しますか？
  I00000336: new CodeTextEnum('I00000336'), //選択した速報版報告書を確認済みにします。よろしいでしょうか？
  I00000337: new CodeTextEnum('I00000337'), //選択した正式版報告書を確認済みにします。よろしいでしょうか？
  E00000338: new CodeTextEnum('E00000338'), //入力が無効です。もう一度正しい情報を入力してください。
  E00000339: new CodeTextEnum('E00000339'), //「基本設定を適用」に戻すと「スポット登録」が削除されます。よろしいですか？
  E00000340: new CodeTextEnum('E00000340'), //発注日と締め日の範囲を正しく入力してください。
  E00000341: new CodeTextEnum('E00000341'), //締め日と確認表出力日の範囲を正しく入力してください。
  E00000342: new CodeTextEnum('E00000342'), //締め日自動送信は１～３１までの日付範囲で入力してください。
  E00000343: new CodeTextEnum('E00000343'), //作業日マッチングの最大案件数は30件です。これ以上設定できません。
  W00000344: new CodeTextEnum('W00000344'), //日程提出依頼を取消します、よろしいでしょうか？
  W00000345: new CodeTextEnum('W00000345'), //{0}画面は既に開かれています。開いている画面を閉じますが、よろしいでしょうか？
  E00000346: new CodeTextEnum('E00000346'), //「電子版工事記録簿」対象のため、「{0}」の変更できません。
  I00000347: new CodeTextEnum('I00000347'), //帳票が正常に出力されました。
  I00000348: new CodeTextEnum('I00000348'), //不可日の催促が完了しました。
  I00000349: new CodeTextEnum('I00000349'), //全商品を他点検との組み合わせ不可で更新します。現在登録されているすべての組み合わせは削除されますが、よろしいですか？
  E00000350: new CodeTextEnum('E00000350'), //不具合ＮＯがブランクの場合、対応状況に”対応中”は選択できません。
  I00000351: new CodeTextEnum('I00000351'), //選択された速報版報告書をPS課確認済みにしました。
  I00000352: new CodeTextEnum('I00000352'), //選択された正式版報告書をPS課確認済みにしました。
  I00000353: new CodeTextEnum('I00000353'), //{0}を催促しました。
  E00000354: new CodeTextEnum('E00000354'), //支店案件は税込１００万円までとなります。１００万円を超える見積書を作成する場合には、建築施設案件としてください。
  E00000355: new CodeTextEnum('E00000355'), //「上記事例に該当しない場合」を選択した場合、他の事例を選択できません。
  W00000356: new CodeTextEnum('W00000356'), //注文書・注文請書に記載された工期を超え、建設業法違反となる可能性があります。契約内容を確認のうえ、必要に応じて後期変更の覚書を締結し、CLOMBSフォルダに電子保存してください。
  E00000357: new CodeTextEnum('E00000357'), //注文請書がe-Fileフォルダに格納されていないため、承認申請できません。
  E00000363: new CodeTextEnum('E00000363'), //すべての書類を確認してください。
  E00000364: new CodeTextEnum('E00000364'), //clombs連携が失敗しました。{0}
  I00000365: new CodeTextEnum('I00000365'), //アップロードされていないすべての書類の提出を催促します。よろしいですか？
  I00000366: new CodeTextEnum('I00000366'), //選択された一部のデータが{0}の対象外です。よろしいでしょうか？{1}：{2}
  E00000367: new CodeTextEnum('E00000367'), //Secom連携が失敗しました。{0}
  E00000368: new CodeTextEnum('E00000368'), //認証エラー：{0}
  E00000369: new CodeTextEnum('E00000369'), //工事記録簿の受注確認登録が未承認で見積採用できません。
  E00000370: new CodeTextEnum('E00000370'), //見積条件書がe-Fileフォルダに格納されていないため、承認申請できません。
  I00000371: new CodeTextEnum('I00000371'), //選択した対象データを催促します。よろしいですか？
  I00000372: new CodeTextEnum('I00000372'), //登録されたデータを取消します。よろしいですか？
  I00000373: new CodeTextEnum('I00000373'), //足場を設置する工事・コア抜きを伴う工事・LN24案件でない漏水調査は専門部署案件として下さい。
  E00000374: new CodeTextEnum('E00000374'), //組み合わせには2つ以上の点検を設定してください。
  E00000375: new CodeTextEnum('E00000375'), //スポットで対応する組み合わせには年月を入力してください。
  E00000376: new CodeTextEnum('E00000376'), //組み合わせには「必須」もしくは「不可」を設定してください。
  I00000377: new CodeTextEnum('I00000377'), //作業内容を更新します。よろしいですか？
  I00000378: new CodeTextEnum('I00000378'), //日程変更依頼を取消します。よろしいでしょうか？
  I00000379: new CodeTextEnum('I00000379'), //日程変更調整を協力会社へ差戻します。よろしいでしょうか？
  I00000380: new CodeTextEnum('I00000380'), //日程変更調整を確定します。よろしいでしょうか？
  I00000381: new CodeTextEnum('I00000381'), //日程変更依頼を登録します。よろしいでしょうか？
  I00000382: new CodeTextEnum('I00000382'), //日程変更依頼を更新します。よろしいでしょうか？
  I00000383: new CodeTextEnum('I00000383'), //入力された商品明細CDは取消されています。取消を解除し、登録してよろしいでしょうか？
  W00000384: new CodeTextEnum('W00000384'), //選択されている全てのデータが処理対象外です。データを再選択してください。
  E00000385: new CodeTextEnum('E00000385'), //{0}テーブルのステータスがTOMOONI Works側と一致しないため、受注キー{1}の取込が失敗しました。関連テーブル：{2}
  E00000386: new CodeTextEnum('E00000386'), //{0}テーブルの取込が失敗しました。項目：{1}
  E00000387: new CodeTextEnum('E00000387'), //取込が失敗したデータ数は{0}件でした。
  E00000388: new CodeTextEnum('E00000388'), //作業完了または原価計上されているため、{0}できません。
  I00000389: new CodeTextEnum('I00000389'), //データ作成しました。
  E00000390: new CodeTextEnum('E00000390'), //ZIPファイル解凍時に異常が発生しました。ファイル名：{0}
  I00000391: new CodeTextEnum('I00000391'), //画面に入力された情報が破棄されます。宜しいでしょうか？
  E00000392: new CodeTextEnum('E00000392'), //S3ファイルサーバー連携が失敗しました。
  E00000393: new CodeTextEnum('E00000393'), //メール送信が失敗しました。
  E00000394: new CodeTextEnum('E00000394'), //SECOM連携が失敗しました。
  E00000395: new CodeTextEnum('E00000395'), //ODATA連携が失敗しました。
  E00000396: new CodeTextEnum('E00000396'), //E-FILEサーバー連携が失敗しました。
  E00000397: new CodeTextEnum('E00000397'), //CLOMBS連携が失敗しました。
  E00000398: new CodeTextEnum('E00000398'), //異常終了、後継のバッチを止める必要があります。
  E00000399: new CodeTextEnum('E00000399'), //正常終了（ワーニングあり）、後継のバッチを止める必要はありません。
  E00000400: new CodeTextEnum('E00000400'), //{0}が見つかりませんでした。
  I00000401: new CodeTextEnum('I00000401'), //アップロードファイルを選択してください。
  I00000402: new CodeTextEnum('I00000402'), //選択した適用期間の基本設定を削除します。スポット登録も同時に削除しますが、よろしいでしょうか？
  I00000403: new CodeTextEnum('I00000403'), //実行結果ファイルが出力されましたので、ご確認をお願いいたします。
  E00000404: new CodeTextEnum('E00000404'), //発注日と確認表出力日の範囲を正しく入力してください。
  E00000405: new CodeTextEnum('E00000405'), //受注データの進行部門CDあるいは計上部門CDが変更されています。「発注キャンセル」を行なってください。
  E00000406: new CodeTextEnum('E00000406'), //入力した進行部門は受注データの進行部門あるいは計上部門と異なります。受注の進行部門もしくは計上部門を選んでください。
  E00000407: new CodeTextEnum('E00000407'), //入力した進行部門は受注データの進行部門あるいは計上部門と異なります。承認することはできません。
  I00000408: new CodeTextEnum('I00000408'), //ページ移動前に保存されていないデータを保存します。よろしいですか？
  I00000409: new CodeTextEnum('I00000409'), //更新が完了しました。
  I00000410: new CodeTextEnum('I00000410'), //設定した内容を登録します。よろしいですか？
  I00000411: new CodeTextEnum('I00000411'), //登録が完了しました。
  I00000412: new CodeTextEnum('I00000412'), //削除します。よろしいでしょうか？
  I00000413: new CodeTextEnum('I00000413'), //同一の内容が既に一覧に追加されています。
  I00000414: new CodeTextEnum('I00000414'), //削除が完了しました。
  I00000415: new CodeTextEnum('I00000415'), //設定した内容で候補日を回答します。よろしいですか？
  I00000416: new CodeTextEnum('I00000416'), //設定した内容で依頼します。よろしいですか？
  I00000417: new CodeTextEnum('I00000417'), //一括通知が完了しました。
  I00000418: new CodeTextEnum('I00000418'), //確認が完了しました。
  I00000419: new CodeTextEnum('I00000419'), //作業完了取り消しの実行が完了しました。
  I00000420: new CodeTextEnum('I00000420'), //提出催促が完了しました。
  I00000421: new CodeTextEnum('I00000421'), //書類の提出催促が完了しました。
  I00000422: new CodeTextEnum('I00000422'), //日程の提出催促が完了しました。
  I00000423: new CodeTextEnum('I00000423'), //協力会社の候補日を差し戻します。よろしいですか？
  I00000424: new CodeTextEnum('I00000424'), //依頼が完了しました。
  I00000425: new CodeTextEnum('I00000425'), //選択された協力会社の該当案件について、全ての書類を「確認済み」に変更します。よろしいですか？
  I00000426: new CodeTextEnum('I00000426'), //画面に入力された内容で協力会社へ依頼します、よろしいでしょうか？
  I00000427: new CodeTextEnum('I00000427'), //設定した内容で回答します。よろしいですか？
  W00000428: new CodeTextEnum('W00000428'), //不可日を含む選択できません。
  I00000429: new CodeTextEnum('I00000429'), //アップロードに成功しました。
  I00000430: new CodeTextEnum('I00000430'), //ダウンロードしました。
  I00000431: new CodeTextEnum('I00000431'), //再提出依頼します。よろしいですか？
  E00000432: new CodeTextEnum('E00000432'), //実施日と工事・作業完了日の範囲を正しく入力してください。
  E00000433: new CodeTextEnum('E00000433'), //日付の範囲を正しく入力してください。
  I00000434: new CodeTextEnum('I00000434'), //選択を解除します。よろしいですか？
  E00000435: new CodeTextEnum('E00000435'), //依頼先を追加してください。
  E00000436: new CodeTextEnum('E00000436'), //更新対象データがありませんでした。
  I00000437: new CodeTextEnum('I00000437'), //選択した適用期間の基本設定を削除します。よろしいでしょうか？
  E00000438: new CodeTextEnum('E00000438'), //納品は{0}にお願いいたします。
  I00000439: new CodeTextEnum('I00000439'), //ページ移動前に保存されていないデータ（無効な入力データを除く）を保存します。よろしいですか？
  I00000440: new CodeTextEnum('I00000440'), //候補日の回答が完了しました。
  I00000441: new CodeTextEnum('I00000441'), //候補日から工事・作業を行う日程を選択してください。
  I00000442: new CodeTextEnum('I00000442'), //差し戻しが完了しました。
  I00000443: new CodeTextEnum('I00000443'), //保存しました。
  I00000444: new CodeTextEnum('I00000444'), //提出依頼が完了しました。
  I00000445: new CodeTextEnum('I00000445'), //依頼の取り消しが完了しました。
  I00000446: new CodeTextEnum('I00000446'), //出力しました。
  I00000447: new CodeTextEnum('I00000447'), //キャンセル済み。
  I00000448: new CodeTextEnum('I00000448'), //資料の連携が完了しました。
  I00000449: new CodeTextEnum('I00000449'), //設定した内容で回答しますか？
  I00000450: new CodeTextEnum('I00000450'), //対応日の回答が完了しました。
  I00000451: new CodeTextEnum('I00000451'), //回答が完了しました。
  I00000452: new CodeTextEnum('I00000452'), //提出が完了しました。
  I00000453: new CodeTextEnum('I00000453'), //催促が完了しました。
  I00000454: new CodeTextEnum('I00000454'), //表示項目設定をリセットしました。
  I00000455: new CodeTextEnum('I00000455'), //表示項目設定を保存しました。
  I00000456: new CodeTextEnum('I00000456'), //削除しました。
  I00000457: new CodeTextEnum('I00000457'), //登録しました。
  I00000458: new CodeTextEnum('I00000458'), //最大10件まで登録できます。
  I00000459: new CodeTextEnum('I00000459'), //重複した条件が存在しています。
  I00000460: new CodeTextEnum('I00000460'), //点検組織CDあるいは建物CDのいずれかを指定して下さい。
  I00000461: new CodeTextEnum('I00000461'), //送信が成功しました。
  I00000462: new CodeTextEnum('I00000462'), //案件担当者の更新が完了しました。
  I00000463: new CodeTextEnum('I00000463'), //取り消しが完了しました。
  W00000464: new CodeTextEnum('W00000464'), //対応日程で指定して日程が重複しています。
  I00000465: new CodeTextEnum('I00000465'), //{0}をチェックしていないため、{1}ができません。
  I00000466: new CodeTextEnum('I00000466'), //{0}してよろしいでしょうか？
  E00000467: new CodeTextEnum('E00000467'), //必須項目です。
  I00000468: new CodeTextEnum('I00000468'), //拡張子がxlsまたはxlsxのファイルのみアップロード可能です。
  E00000469: new CodeTextEnum('E00000469'), //情報の取得に失敗しました。
  E00000470: new CodeTextEnum('E00000470'), //商品ＣＤ＋商品明細ＣＤを重複して入力することはできません。{0}
  E00000471: new CodeTextEnum('E00000471'), //指定された得意先ＣＤの請求支払区分が正しくありません。
  E00000472: new CodeTextEnum('E00000472'), //指定された得意先ＣＤは取引できません。
  E00000473: new CodeTextEnum('E00000473'), //{0}が指定されていません。
  E00000474: new CodeTextEnum('E00000474'), //{0}は指定できません。
  E00000475: new CodeTextEnum('E00000475'), //指定された商品ＣＤの受託作業区分が受託です。
  E00000476: new CodeTextEnum('E00000476'), //指定された商品明細ＣＤは無効です。
  E00000477: new CodeTextEnum('E00000477'), //直受注可能な商品ＣＤを入力してください。
  E00000478: new CodeTextEnum('E00000478'), //契約開始日は1975年4月1日以降を入力してください。
  E00000479: new CodeTextEnum('E00000479'), //契約終了日は2050年3月31日よりも前に設定してください。
  E00000480: new CodeTextEnum('E00000480'), //件名の長さが７４バイトを超えています。
  E00000481: new CodeTextEnum('E00000481'), //指定された計上部門ＣＤは計上部門ではありません。
  E00000482: new CodeTextEnum('E00000482'), //指定された計上部門ＣＤは使用できません。
  E00000483: new CodeTextEnum('E00000483'), //指定された計上担当者ＣＤは退職しています。
  E00000484: new CodeTextEnum('E00000484'), //商品明細金額税抜が0円以下では登録できません。
  E00000485: new CodeTextEnum('E00000485'), //受注承認者ＣＤが承認者クラス管理に登録されていません。
  E00000486: new CodeTextEnum('E00000486'), //請求予定日は本日以降の日付を指定してください。
  E00000487: new CodeTextEnum('E00000487'), //ＭＳ会計ＣＤが建物ＣＤに対応していません。
  E00000488: new CodeTextEnum('E00000488'), //入金予定日は請求予定日以降を入力してください。
  E00000489: new CodeTextEnum('E00000489'), //{0}の値が不正です。
  E00000490: new CodeTextEnum('E00000490'), //{0}が組織名称マスタに登録されていません。
  E00000491: new CodeTextEnum('E00000491'), //の指定に誤りがあります。
  E00000492: new CodeTextEnum('E00000492'), //{0}が取引先マスタに登録されていません。
  E00000493: new CodeTextEnum('E00000493'), //{0}が全社員マスタに登録されていません。
  E00000494: new CodeTextEnum('E00000494'), //「計上部門ＣＤ」が計上部門ではありません。
  E00000495: new CodeTextEnum('E00000495'), //「作業予定日」「開始時間」「終了時間」が重複しています。
  E00000496: new CodeTextEnum('E00000496'), //が作業予実に登録されていません。
  E00000497: new CodeTextEnum('E00000497'), //「建物ＣＤ」「棟ＣＤ」が建物基本マスタに登録されていません。
  E00000498: new CodeTextEnum('E00000498'), //{0}は、10桁以内の整数を入力してください。
  E00000499: new CodeTextEnum('E00000499'), //{0}が商品明細マスタに登録されていません。
  E00000500: new CodeTextEnum('E00000500'), //「商品ＣＤ」の受託作業区分が受託です。
  E00000501: new CodeTextEnum('E00000501'), //「商品ＣＤ」が商品マスタに登録されていません。
  E00000502: new CodeTextEnum('E00000502'), //予定売上額 が4,545,455円を超えています。
  E00000503: new CodeTextEnum('E00000503'), //予定原価額 が40,909,091円を超えています。
  E00000504: new CodeTextEnum('E00000504'), //{0}の場合、 {1}に「工事」を含めることはできません。
  E00000505: new CodeTextEnum('E00000505'), //の値が不正です。
  E00000506: new CodeTextEnum('E00000506'), //が指定されていません。
  E00000507: new CodeTextEnum('E00000507'), //が全社員マスタに登録されていません。
  E00000508: new CodeTextEnum('E00000508'), //ＭＳ会計ＣＤ が会計マスタに登録されていません。
  E00000509: new CodeTextEnum('E00000509'), //ＭＳ科目ＣＤが勘定科目マスタに登録されていません。
  E00000510: new CodeTextEnum('E00000510'), //が組織名称マスタに登録されていません。
  E00000511: new CodeTextEnum('E00000511'), //が取引先マスタに登録されていません。
  E00000512: new CodeTextEnum('E00000512'), //が全社員マスタに登録されていません。
  E00000513: new CodeTextEnum('E00000513'), //は、10桁以内の整数を入力してください。
  E00000514: new CodeTextEnum('E00000514'), //受注キーとＲＣ改定ＮＯはどちらも設定されていません。
  E00000515: new CodeTextEnum('E00000515'), //ファイルサイズは{0}以下にしてください。
  E00000516: new CodeTextEnum('E00000516'), //{0}の指定に誤りがあります。
  I00000517: new CodeTextEnum('I00000517'), //{0}が開始しました。
  I00000518: new CodeTextEnum('I00000518'), //{0}をe-fileサーバ（パス：{1}）へ格納しました。
  I00000519: new CodeTextEnum('I00000519'), //{0}の登録が成功しました。
  I00000520: new CodeTextEnum('I00000520'), //ファイル名：{0}を{1}に格納しました。
  I00000521: new CodeTextEnum('I00000521'), //SPAIS転送テーブルの情報（パス、ファイル名）を更新しました。
  E00000522: new CodeTextEnum('E00000522'), //アップロードに失敗しました。
  I00000523: new CodeTextEnum('I00000523'), //アップロードするファイルを追加してください。
  E00000524: new CodeTextEnum('E00000524'), //どれか１つは条件を指定してください。
  W00000525: new CodeTextEnum('W00000525'), //{0}件以上のデータを出力できません、データを絞り込んでください。
  W00000526: new CodeTextEnum('W00000526'), //建物科目マスタに登録されていない科目コードとなります。
  E00000527: new CodeTextEnum('E00000527'), //{0}は入力できません。
  E00000528: new CodeTextEnum('E00000528'), //{0}は{1}以降を入力してください。
  E00000529: new CodeTextEnum('E00000529'), //有効開始予定年月、次回作成年月、次回契約予定開始年月の入力に誤りがあります。（「有効開始予定年月」 ≦ 「次回作成年月」 ≦ 「次回契約予定開始年月」として入力してください。）
  E00000530: new CodeTextEnum('E00000530'), //{0}は{1}よりも前のため、{2}を入力してください。
  E00000531: new CodeTextEnum('E00000531'), //指定した次回契約予定開始年月以降に受注データが存在します。
  E00000532: new CodeTextEnum('E00000532'), //{0}は今月以降を入力してください。
  E00000533: new CodeTextEnum('E00000533'), //有効終了年月より後に受注期間が存在するため、終了できません。
  E00000534: new CodeTextEnum('E00000534'), //{0}が指定されていないので{1}は入力できません。
  E00000535: new CodeTextEnum('E00000535'), //{0}は{1}から{2}までの値を入力してください。
  E00000536: new CodeTextEnum('E00000536'), //予定売上額又は、原価回数が入力されているため、商品明細の変更はできません。
  E00000537: new CodeTextEnum('E00000537'), //同一{0}が既に登録されています。
  E00000538: new CodeTextEnum('E00000538'), //指定された{0}は、マイナスの入力はできません。
  E00000539: new CodeTextEnum('E00000539'), //{0}は許されていません。
  E00000540: new CodeTextEnum('E00000540'), //{0}が{1}に変更できません。
  E00000541: new CodeTextEnum('E00000541'), //役務案件のため、原価承認・見積承認申請を兼ねて行います。売価入力完了をチェックしてください。
  W00000542: new CodeTextEnum('W00000542'), //{0}の以降に、納品完了済の受注詳細データが存在しています。
  W00000543: new CodeTextEnum('W00000543'), //発注詳細の計上日はセットされているデータが存在しています、{0}を指定してよろしいでしょうか。
  I00000544: new CodeTextEnum('I00000544'), //一括請求にする場合、受注請求データを再計算してもよろしいでしょうか？再計算は「請求年月日」を入力してから行います。
  E00000545: new CodeTextEnum('E00000545'), //{0}～{1}までの日付を指定してください。
  W00000546: new CodeTextEnum('W00000546'), //取消された受注詳細と関連している未取消の発注詳細があります。{0}してよろしいでしょうか。
  E00000547: new CodeTextEnum('E00000547'), //契約開始予定年月と総会年月の期間が1か月以内となっているため、発注先へ事前連絡をお願いします。
  E00000548: new CodeTextEnum('E00000548'), //{0}の変更がないため、{1}できません。
  E00000549: new CodeTextEnum('E00000549'), //有効開始予定年月が今月より未来のため、手動作成対象外です。
  E00000550: new CodeTextEnum('E00000550'), //次回契約予定開始年月の実施周期をまたいで登録できないため、入力された契約開始日に対して、作成可能な契約期間がありません。
  E00000551: new CodeTextEnum('E00000551'), //{0}は{1}で入力してください。
  E00000552: new CodeTextEnum('E00000552'), //受託以外の場合、{0}は{1}を入力してください。
  E00000553: new CodeTextEnum('E00000553'), //契約期間内に作成する提案計画が存在しません。
  E00000554: new CodeTextEnum('E00000554'), //指定した契約期間内に受注データが存在します。
  E00000555: new CodeTextEnum('E00000555'), //ＲＣ改定承認待ち案件（ＲＣ改定ＮＯ：{0}）があります。承認作業を完了させてから受注更新を行ってください。
  E00000556: new CodeTextEnum('E00000556'), //登録・変更中・承認待ちの受注・発注データが存在するため、{0}ができません。「受注・発注一覧」画面にてご確認ください。
  E00000557: new CodeTextEnum('E00000557'), //{0} は{1}以内を指定してください。
  E00000558: new CodeTextEnum('E00000558'), //登録中の受注（受注キー：{0}）があります。登録作業を完了してから採用承認依頼を行ってください。
  E00000559: new CodeTextEnum('E00000559'), //登録、変更中の受注が存在するため、終了できません。
  E00000560: new CodeTextEnum('E00000560'), //見積有効期限を過ぎています、見積書はドラフト印刷のみ可能です。
  I00000561: new CodeTextEnum('I00000561'), //検索する前に保存されていないデータを保存します。よろしいですか？
  E00000562: new CodeTextEnum('E00000562'), //決算処理済みのため変更できません。
  E00000563: new CodeTextEnum('E00000563'), //異なる税率の商品明細が登録されている請求済データのため、変更できません。
  E00000564: new CodeTextEnum('E00000564'), //納品予定日変更により、この受注詳細は新しい税率に適用されることになるため、更新できません。
  W00000565: new CodeTextEnum('W00000565'), //{0}から新しい金額を適用します、全ての月の金額を登録しましたか。
  E00000566: new CodeTextEnum('E00000566'), //承認者が指定されていないため、承認申請できません。
  I00000567: new CodeTextEnum('I00000567'), //当画面で設定した条件より、作業条件の方が優先です。作業条件に該当が無い場合、当画面の条件がカレンダーに適用されます。
  E00000568: new CodeTextEnum('E00000568'), //{0}できません。
  I00000569: new CodeTextEnum('I00000569'), //入力された改定予定開始年月{0}以降には改定となる受注はありません。新規に受注自動作成か行われます。{1}
  E00000570: new CodeTextEnum('E00000570'), //{0}には{1}が､既に存在しています｡
  E00000571: new CodeTextEnum('E00000571'), //指定された受注キーは受注で商品明細が取消されています。{0}
  E00000572: new CodeTextEnum('E00000572'), //{0}の受注詳細が取消されました。{1}
  E00000573: new CodeTextEnum('E00000573'), //指定された受注キーは受注キャンセル済みのため、{0}
  E00000574: new CodeTextEnum('E00000574'), //見積を採用することがあるため、お客様注文書・納品書登録出来ません。
  E00000586: new CodeTextEnum('E00000586'), //{0}変更することはできません。
  E00000587: new CodeTextEnum('E00000587'), //{0}存在しません。
  I00000588: new CodeTextEnum('I00000588'), //作業年月：{0}、管理部門：{1}、{2}の値が設定されないです。
  E00000589: new CodeTextEnum('E00000589'), //商品明細ＣＤの入力に誤りがあるためファイルの移動に失敗しました。
  E00000590: new CodeTextEnum('E00000590'), //作業ＮＯの入力に誤りがあるため作業完了登録に失敗しました。
  E00000591: new CodeTextEnum('E00000591'), //ファイルが開いているため移動できませんでした。手動からファイルを移動してください。
  E00000592: new CodeTextEnum('E00000592'), //ファイル移動に失敗しました。
  E00000593: new CodeTextEnum('E00000593'), //作業完了登録に失敗しました。
  E00000594: new CodeTextEnum('E00000594'), //建物CDが作業NOに登録されている建物CDと相違があります。
  E00000595: new CodeTextEnum('E00000595'), //既に作業予実に中止日が登録されているため処理を中断しました。
  E00000596: new CodeTextEnum('E00000596'), //発注ステータスの関係により処理を中断しました。
  E00000597: new CodeTextEnum('E00000597'), //回数が入力されてないため、{0}の入力はできません。
  I00000598: new CodeTextEnum('I00000598'), //契約開始年月が総会月の翌月となっていますので、協力会社との発注関係の手続きについて、ご注意ください。
  E00000599: new CodeTextEnum('E00000599'), //該当商品明細を紐づく受注詳細が取消されました。{0}
  E00000600: new CodeTextEnum('E00000600'), //指定された受注はキャンセルされていますが、{0}
  W00000601: new CodeTextEnum('W00000601'), //{0}が存在しています。{1}してよろしいでしょうか。
  E00000602: new CodeTextEnum('E00000602'), //受注基本情報(TJCUBASP)のステータスがSO側と一致しないため、受注キー｛0｝の取込が失敗しました。
  E00000603: new CodeTextEnum('E00000603'), //実施対象のデータがありません。受注キー{0}
  I00000604: new CodeTextEnum('I00000604'), //{0}を行いますが宜しいでしょうか？宜しい場合は、「確定」ボタンを押してください。
  E00000605: new CodeTextEnum('E00000605'), //「原価承認待ち」もしくは「原価承認保留中」の商品明細があるため、未採用できません。
  E00000606: new CodeTextEnum('E00000606'), //{0}テーブルのステータスがTOMOONI Works側と一致しないため、提案計画ＮＯ{1}の取込が失敗しました。関連テーブル：{2}
  E00000607: new CodeTextEnum('E00000607'), //{0} できる最大行数を超えています。{1} 可能最大行数：{2}
  E00000608: new CodeTextEnum('E00000608'), //{0} は{1} まで登録が可能です。
  E00000609: new CodeTextEnum('E00000609'), //商品ＣＤが0150または0151の場合、提案種別分類は必須となります。
  E00000610: new CodeTextEnum('E00000610'), //1行目B列に「【取り込み済み 】」の文字列が存在しています。
  I00000611: new CodeTextEnum('I00000611'), //取込条件が満たされていないため、スキップします。
  W00000612: new CodeTextEnum('W00000612'), //{0} が指定されていません。
  E00000613: new CodeTextEnum('E00000613'), //原価実施周期がブランクではないデータが存在するため、実施周期に「1年」以上を指定できません。商品明細の原価実施周期を改定してから実施周期を変更してください。
  E00000614: new CodeTextEnum('E00000614'), //ファイルの拡張子は「.xlsx」「.xls」「.pdf」のみ有効です。
  E00000615: new CodeTextEnum('E00000615'), //報告書提出済みによりアップロード出来ません。
  E00000616: new CodeTextEnum('E00000616'), //作業No：＜作業No＞：提出済みにより処理出来ません。
  E00000617: new CodeTextEnum('E00000617'), //作業No：＜作業No＞：発注キャンセルにより処理できません。
  E00000618: new CodeTextEnum('E00000618'), //作業No：＜作業No＞：存在しないため処理できません。
  I00000619: new CodeTextEnum('I00000619'), //アップロードしたファイルの内容がシステムに反映されるまで最長で{0}程度時間がかかる場合がございます。あらかじめご了承下さい。
  E00000620: new CodeTextEnum('E00000620'), //所属組織の取引先CDがありません、管理者にご確認ください。
  E00000621: new CodeTextEnum('E00000621'), //アップロードのファイル名には次の文字（半角）は使えません。  ¥ / : * ? " < > | +
  E00000622: new CodeTextEnum('E00000622'), //{0}場合、作業完了取消はできません。
  E81000001: new CodeTextEnum('E81000001'), //タブやブラウザが想定外終了。
  E81000002: new CodeTextEnum('E81000002'), //task id is null エラー。
  E81000003: new CodeTextEnum('E81000003'), //efile サービス500を戻すエラー。
  E81000004: new CodeTextEnum('E81000004'), //efile サービス502を戻すエラー。
  E84000004: new CodeTextEnum('E84000004'), //メール送信が失敗しました。
  E90000001: new CodeTextEnum('E90000001'), //システムエラーが発生しました。システム管理者へ連絡してください。
  E90000002: new CodeTextEnum('E90000002'), //DBエラーが発生しました。
  E90000003: new CodeTextEnum('E90000003'), //ファイルサーバ(S3)への処理が失敗しました。
  E90000004: new CodeTextEnum('E90000004'), //メール送信が失敗しました。
  E90000005: new CodeTextEnum('E90000005'), //Odata連携が失敗しました。
  E90000006: new CodeTextEnum('E90000006'), //ファイルサーバ(e-file)への処理が失敗しました。{0}
  E90000007: new CodeTextEnum('E90000007'), //clombs連携が失敗しました。
  E90000008: new CodeTextEnum('E90000008'), //Secom連携が失敗しました。
  E90000009: new CodeTextEnum('E90000009'), //帳票非同期処理がタイムアウトしました。
  E90001001: new CodeTextEnum('E90001001'), //バッチ処理でエラーが発生して、連携が失敗しました。
  E90001002: new CodeTextEnum('E90001002'), //バッチ処理で警告終了しました。
})
module.exports = { messageCodeEnum }
